module.exports = __webpack_public_path__ + "img/home_header_mask_tall.c2f859ab.png";